export class AppConfig {
    // public static BASE_URL = `https://web.vyaparlive.com`;
    // public static BASE_URL = `https://demo.vyaparlive.com`;
    public static BASE_URL = process.env.REACT_APP_BASE_URL || 'https://demo.vyaparlive.com';
    public static IMAGE_PATH = "https://vyapar-data.s3.ap-south-1.amazonaws.com/";
    public static RETAIL_PORT = 8089;
}